export const getEnabledQueryBasedOnOfflineMode = (isOfflineMode: boolean | undefined) =>
  isOfflineMode ? true : undefined;
